import { Draft, PayloadAction } from '@reduxjs/toolkit';
import IWorker from 'models/Worker';

import { IWorkerData } from '../../initialState';

interface IDeleteWorkerSuccessAction {
  worker: IWorker;
}

function deleteSuccess(
  draft: Draft<IWorkerData>,
  action: PayloadAction<IDeleteWorkerSuccessAction>,
) {
  draft.delete.config.isLoading = false;
  draft.getAll.list = draft.getAll.list.filter(worker => {
    return worker.id !== action.payload.worker.id;
  });
}

export default deleteSuccess;
